import { useEffect, useState } from 'react';
import { usePageProps } from '../context/PagePropContext';

const langCodes = ['es'];

const getLangRegex = new RegExp(`^\/?(${langCodes.join('|')})($|\/)`, 'i');

export const getLanguage = (path: string) => {
  const searchResults = path.match(getLangRegex);
  if (!searchResults) return 'en';
  return searchResults[1].toLowerCase();
}

const useLanguage = (defaultPath = '') => {
  const { path = '' } = usePageProps();
  const [lang, setLang] = useState(getLanguage(path || defaultPath));

  useEffect(() => {
    if (path) {
      setLang(getLanguage(path));
    }
  }, [path]);

  return { lang };
}

export default useLanguage;